import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ONBOARD_CONSTANTS } from '../app.constants';
import { AppService } from '../app.service';
import { HttpService } from '../services/http.service';
import { AccessibilityService } from '../services/accessibility.service';
import { ErrorService } from '../components/error/error.service';
import { DatalayerService } from '../services/datalayer.service';
import { LandingService } from '../components/landing/landing.service';
import { TravelersService } from '../components/travelers/travelers.service';
import { LandingComponent } from '../components/landing/landing.component';

@Injectable()
export class ActivateService {
  isCharterFlight;
  constructor(private appService: AppService,
    private httpService: HttpService,
    private errorService: ErrorService,
    private accessibilityService: AccessibilityService,
    private datalayerService: DatalayerService,
    private landingService: LandingService,
    private activatedRoute: ActivatedRoute,
    private travelersService: TravelersService,
    private router: Router) { }

  doActivateCall(request): Observable<any> {
    let voucherConnect = (request && request.data 
      && request.data.passenger && request.data.passenger.voucherCode)?true:false;

    this.isCharterFlight = this.appService.getFlightServiceType();
    return this.httpService.postData(request)
      .map(activateResponse => {
        if (activateResponse.links) {
          this.appService.setPassengerIdData(activateResponse.links);
        }

        if (!activateResponse.errors && activateResponse.status && activateResponse.status.code === 'FULL') {
          this.accessibilityService.setSkipLinkId('buy-wifi-home');
          this.landingService.hideLandingBannerText();
          this.appService.hideLoaderWithText();
          this.landingService.getNetFlixBanner(activateResponse.status.code);
          this.landingService.getGetDeviceResponse()['status'] = activateResponse.status;
          this.errorService.addConnectedNotification();
          this.appService.changeDisconnectWifiStatus();
          this.appService.showLandingCustomer();
          this.appService.setActivateStatus(true);
          this.appService.addScrollBody();
          this.appService.hideLoader();
          this.appService.scrollToTop();
          LandingComponent.voucherConnect= voucherConnect;
         
          if (this.isCharterFlight) {
            this.datalayerService.activateDataLayer('Connection successful  - Email');
            this.charterFlowDatalayer(activateResponse);
            this.appService.hideLoaderWithText();
          }
          if (!ONBOARD_CONSTANTS.ENABLE_DEVICE_TOKEN_STRIPPING) {
            this.activatedRoute.queryParams.subscribe(params => {
              if (!params.deviceToken) {
                this.router.navigate([''], { queryParams: { 'deviceToken': sessionStorage.getItem('deviceToken') } });
              }
            });
          }
        } else {
          this.errorService.addError(this.landingService.getDefaultError());
          this.appService.hideLoader();
          this.appService.hideLoaderWithText();
        }

        return activateResponse;
      });
  }

  doCrewActivateCall(request): Observable<any> {
    return this.httpService.postData(request)
      .map(activateResponse => {
      
        if (!activateResponse.errors && activateResponse.status && activateResponse.status.code === 'FULL') {
          this.accessibilityService.setSkipLinkId('buy-wifi-home');
          this.landingService.hideLandingBannerText();
          this.appService.hideLoaderWithText();
          this.landingService.getNetFlixBanner(activateResponse.status.code);
          this.landingService.getGetDeviceResponse()['status'] = activateResponse.status;
         // this.landingService.hideBuyBtn();
          this.errorService.addConnectedNotification();
          this.appService.changeDisconnectWifiStatus();
          this.appService.showLandingCustomer();
          this.appService.setActivateStatus(true);
          this.appService.addScrollBody();
          this.appService.hideLoader();
          this.appService.scrollToTop();
         // this.appService.buyMoreDevices();
          this.router.navigate(['/home']);
          
        
          if (!ONBOARD_CONSTANTS.ENABLE_DEVICE_TOKEN_STRIPPING) {
            this.activatedRoute.queryParams.subscribe(params => {
              if (!params.deviceToken) {
                this.router.navigate(['voucher'], { queryParams: { 'deviceToken': sessionStorage.getItem('deviceToken') } });
              }
            });
          }
        } else {
          
          this.errorService.addError(this.landingService.getDefaultError());
          this.appService.hideLoader();
          this.appService.hideLoaderWithText();
        }
        
        return activateResponse;
      });
  }
  charterFlowDatalayer(activateResponse) {
    let segmentInfoMap = new Map();
    segmentInfoMap = this.travelersService.getSegmentInfoDataFromFlightResponse(segmentInfoMap);
    const activateDeviceDataMap = this.travelersService.getActivateDeviceDetails(activateResponse);
    this.datalayerService.postActivateDataLayerSuccess(segmentInfoMap, activateDeviceDataMap);
  }
}
